import { FormattedMessage } from 'react-intl';

import type { ProductType } from '@xing-com/crate-common-graphql-types';
import { Headline as BreweryHeadline } from '@xing-com/typography';

interface HeadlineProps {
  product: ProductType;
  className?: string;
}
export function Headline({
  product,
  className = '',
}: HeadlineProps): JSX.Element {
  return (
    <BreweryHeadline
      as="p"
      size="xxlarge"
      sizeWide="xxxlarge"
      noMargin
      className={className}
    >
      {product === 'projobs' ? (
        <FormattedMessage id="UPSELL_PURCHASE_OFFER_BOX_HEADLINE_PROJOBS" />
      ) : (
        <FormattedMessage id="UPSELL_PURCHASE_OFFER_BOX_HEADLINE" />
      )}
    </BreweryHeadline>
  );
}
